import type { EditSelectOptionList } from 'components/forms/EditSelect';
import type { ScheduleNext } from 'api/recurrence_definitions/endpoints/types';

/**
 * Shared schedule_next choices for every surface that asks when to create the
 * next occurrence (definition editor, manual submit, update-instance schedule).
 * Keep labels in sync here — do not re-declare in call sites.
 */
export const SCHEDULE_NEXT_OPTIONS: EditSelectOptionList<ScheduleNext> = [
  { key: 'on_complete', value: 'on_complete', label: 'When the run finishes (default)' },
  { key: 'on_start', value: 'on_start', label: 'When the run starts' },
];

/** Tooltip for the schedule-next control (long runs / stage next / hold). */
export const SCHEDULE_NEXT_INFO =
  'For long-running jobs, create the next occurrence when this run starts so you can prepare the following run (for example put it on hold) while the current instance is still active. Overlapping runs remain possible — use hold or locks if they must not collide.';

/** Base resubmit-on-error tooltip when schedule_next is not on_start. */
export const RESUBMIT_ON_ERROR_DEFAULT_INFO = 'Automatically resubmit the job if it fails';

/** Tooltip for resubmit-on-error while schedule_next is on_start. */
export const RESUBMIT_ON_ERROR_IGNORED_ON_START_INFO =
  'Ignored while “Schedule next occurrence” is set to when the run starts — the next occurrence is created at start, before the outcome is known.';
